import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { ManagerFooterMenu } from '../../../utils/menu';

const ManagerFooter = () => {
  const location = useLocation();
  return (
    <FooterWrapper>
      <ul>
        {ManagerFooterMenu.map((item, index) => (
          <li
            key={index}
            className={location.pathname === item.path ? 'active' : ''}
          >
            <Link
              to={{
                pathname: item.path,
                state: {
                  auth: 'manager',
                },
              }}
            >
              <div className="icon-box">{<item.icon />}</div>
              <span>{item.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </FooterWrapper>
  );
};

export default ManagerFooter;

// style
const FooterWrapper = styled.footer`
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 10rem;
  padding: 1rem 2rem;
  background-color: ${(props) => props.theme.textWhiteColor};
  ul {
    display: flex;
    justify-content: center;
    gap: 1.6rem;
    width: 100%;
    li {
      a {
        padding: 0.9rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        width: 5.4rem;
        height: 5.4rem;
        .icon-box {
          display: flex;
        }
        span {
          font-size: 1.1rem;
          color: ${(props) => props.theme.joinLabelColor};
        }
      }
      &.active {
        a {
          span {
            color: ${(props) => props.theme.textBlackColor};
          }
          .icon-box {
            svg {
              path {
                fill: ${(props) => props.theme.textBlackColor};
              }
            }
          }
        }
      }
    }
  }
`;
